import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/system/Box";
import { Grid, Typography, Divider } from "@mui/material";
import RateConfirmationModalSidebarItem from "./RateConfirmationModalSidebarItem/RateConfirmationModalSidebarItem";

export default function RateConfirmationModalSidebar({ load }) {
  return (
    <Box sx={{
      backgroundColor: "black_solid.10",
      margin: "5px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: "20px",
      maxWidth: "350px",
      height: "100%"
    }}>
      {load &&
        <>
          <Typography variant="subhead2" color="primary.60" marginBottom="10px">ORDER {load.id}</Typography>
          <Divider />
          <Typography marginY="10px">CREDIT INFORMATION</Typography>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Typography color="black_solid.60">MC #</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>629379</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">DOT #</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>2241050</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">DUNS #</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>00-897-3396</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">TAX ID #</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>45-0582140</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">Email</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography noWrap>loaddelivered@app.hubtran.com</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">Phone</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>877-930-5623</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography color="black_solid.60">Fax</Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography>312-649-6657</Typography>
            </Grid>
          </Grid>
          <Box sx={{ marginTop: "20px", height: "600px", overflowY: "auto" }}>
            {load.stops && load.stops.length > 0 ? load.stops.map((r, i) => (
              <RateConfirmationModalSidebarItem key={i} index={i + 1} stop={r} />
            )) : (
              <Typography color="black_solid.50">No stops found</Typography>
            )}
          </Box>
        </>
      }
    </Box>
  );
}

RateConfirmationModalSidebar.propTypes = {
  load: PropTypes.object,
};